import React, {useRef} from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import {useThemeMode} from '../../../../_metronic/partials'

interface HCaptchaComponentProps {
  siteKey: string
  onVerify: (token: string) => void
}

const HCaptchaComponent: React.FC<HCaptchaComponentProps> = ({siteKey, onVerify}) => {
  const {mode} = useThemeMode()
  const captchaRef = useRef<HCaptcha>(null)

  // system is not handle at hCaptcha as far as i know
  const themeMode = mode === 'system' ? 'light' : mode

  const handleVerify = (token: string | null) => {
    if (token) {
      onVerify(token)
    }
  }

  return (
    <div className='text-end mt-4'>
      <HCaptcha sitekey={siteKey} onVerify={handleVerify} ref={captchaRef} theme={themeMode} />
    </div>
  )
}

export default HCaptchaComponent
